'use client';

import type { CompanyProfileHeroData } from './CompanyProfileSection';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { isoToGerman } from './companyDetailUtils';
import { foundingDateAtPrecision } from '@/lib/company-utils';
import type { TFunction } from 'i18next';

interface FoundingYearChipProps {
  heroData: CompanyProfileHeroData;
  t: TFunction;
}

export function FoundingYearChip({
  heroData,
  t,
}: FoundingYearChipProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="cursor-default">
            {heroData.gruendungsYear}
          </span>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="text-xs">
          <div className="flex flex-col gap-0.5">
            <span className="font-semibold text-center">
              {t('companyDetail.foundingDate', 'Gründungsdatum')}
            </span>
            {heroData.gruendungsdokumentDatum && (
              <span className="tabular-nums">
                {isoToGerman(
                  foundingDateAtPrecision(
                    heroData.gruendungsdokumentDatum,
                  ),
                )}
                :{' '}
                {heroData.gruendungsdokument === 'Satzung'
                  ? t('companyDetail.satzung', 'Satzung')
                  : t(
                      'companyDetail.articlesOfAssociation',
                      'Gesellschaftsvertrag',
                    )}
              </span>
            )}
            {heroData.ersteEintragungDatum && (
              <span className="tabular-nums">
                {isoToGerman(
                  foundingDateAtPrecision(
                    heroData.ersteEintragungDatum,
                  ),
                )}
                :{' '}
                {t(
                  'companyDetail.firstRegistration',
                  'Erste Eintragung',
                )}
              </span>
            )}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
